/** Staff-facing names for the recipient roles a notice rule can require. */
export const recipientRoleLabels: Record<string, string> = {
  owner: 'Owner', 'fee-simple-titleholder': 'Fee simple titleholder', 'owner-designee': 'Owner\'s designee',
  'additional-notice-designee': 'Additional notice designee', contractor: 'Contractor', 'hiring-party': 'Hiring party',
  lender: 'Lender', surety: 'Surety', 'public-authority': 'Public authority',
  'public-authority-representative': 'Public authority representative', other: 'Other recipient',
};
/** A role's name, or one recipient's among several of a role: delivery knows them by key, `role#2` for the second. */
export const recipientLabel = (roleOrKey: string) => {
  const [role, position] = roleOrKey.split('#');
  const label = recipientRoleLabels[role!] ?? role!;
  return position ? `${label} ${position}` : label;
};

/** Staff-facing names for the ways a rule allows a notice to be delivered. */
export const serviceMethodLabels: Record<string, string> = {
  HAND_DELIVERY: 'Hand delivery', CERTIFIED_MAIL: 'Certified mail', REGISTERED_MAIL: 'Registered mail',
  GLOBAL_EXPRESS_GUARANTEED: 'Global Express Guaranteed', COMMON_CARRIER: 'Common carrier (e.g. courier)',
  OVERNIGHT_DELIVERY: 'Overnight delivery', SHERIFF: 'Sheriff', OTHER_WITH_PROOF_OF_RECEIPT: 'Any method with written proof of receipt',
  POSTING_ON_SITE: 'Posting on the job site', DIRECTORY_FILING: 'Filing in the state directory',
};
export const serviceEffectiveLabels: Record<string, string> = {
  MAILING: 'counts as served the day it is mailed', RECEIPT: 'counts as served when received',
  FILING: 'counts as served when filed', POSTING: 'counts as served when posted',
};

/** 15 → 15th, 3 → 3rd: a day or month counted in a deadline. */
export const ordinal = (n: number) => `${n}${n % 100 >= 11 && n % 100 <= 13 ? 'th' : ['th', 'st', 'nd', 'rd'][n % 10] ?? 'th'}`;
